export default {
  roundOnly: true,
  checkoutFormVariant: 'd',
  planSet: 'pricing-21',
  growthbookFeatures: ['supp', 'thankyou_tips'],
};
